module.exports = __webpack_public_path__ + "static/media/kjmlogo-colored.2824f793.png";